import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getFEComponentAuthorized, getUserType } from './store/thunk'

export const ErrorPage = ({ children }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getUserType())
    dispatch(getFEComponentAuthorized())
  }, [])

  return children
}

ErrorPage.propTypes = {
  children: PropTypes.node.isRequired,
}
